import styled from 'styled-components';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './game-details-container.default.box';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';

function common(): string {
    return `
        overflow: initial;
        &:after {
            background-size: 75%;
            opacity: .6;
            height: 15px;
            bottom:-15px;
        }
    `
}

const PcBox = styled(BasePcBox)`
    ${common()}
    &:after {
        bottom:-15px;
    }
`;

const MobileBox =  styled(BaseMobileBox)`
    ${common()}
    &:after {
        bottom:-18px;
    }
`;


export const GameDetailsContainerCasino777Box = styledByDevice(PcBox, MobileBox);